import React from "react";
import {
  Button,
  Label,
  Modal,
  Table,
  TableHeader,
  TableHeaderCell,
  TableRow,
  TableBody,
  DropdownMenu,
  DropdownItem,
  Dropdown,
} from "semantic-ui-react";
import { socket } from "../../../lib/socketio";
import { getTimestamp } from "../../../lib/time";
import { useSelector } from "react-redux";

function EventLog({ totalAlarms, currentPLC }) {
  const [alarmTagData, setalarmTagData] = React.useState();
  const [isCsvDone, setIsCsvDone] = React.useState(false);
  const [saveEventFilePath, setsaveEventFilePath] = React.useState("");

  const [tableData, setTableData] = React.useState([]);
  const timezone = useSelector((state) => state.nav.timezone);
  const [open, setOpen] = React.useState(false);

  const handleOpen = () => {
    setOpen(true);
    fetchEvents();
  };
  const handleClose = () => {
    setOpen(false);
  };

  const saveEventLogs = () => {
    setIsCsvDone(false);
    setalarmTagData(tableData);
  };

  // update SOFC, add save log function by yeonjeong
  React.useEffect(() => {
    if (saveEventFilePath === "") {
      let fileName = "AlarmEventLog_";
      const d = new Date();
      const datestring =
        d.getDate() +
        "-" +
        (d.getMonth() + 1) +
        "-" +
        d.getFullYear() +
        " " +
        d.getHours() +
        "-" +
        d.getMinutes();
      fileName += datestring.replace(/ /g, "_");
      setsaveEventFilePath(fileName);
    }
  }, [saveEventFilePath]);

  // update SOFC, add save log function by yeonjeong
  React.useEffect(() => {
    if (
      typeof alarmTagData !== "undefined" &&
      alarmTagData !== null &&
      isCsvDone === false
    ) {
      const tag_values = Object.values(alarmTagData);
      let csv = "";
      csv += '"TIMESTAMP",';
      csv += '"EVENT NAME",';
      csv += '"CURRENT STATUS",';
      csv += "\r\n";

      tag_values.forEach((a, idx) => {
        // update SOFC 240409 by sumin, to save each PSM's logs
        if (tag_values[idx].alarm_name.startsWith(currentPLC)) {
          let row = "";

          row += '"' + getTimestamp(tag_values[idx].datetime) + '",';
          row += '"' + tag_values[idx].alarm_name + '",';
          row += '"' + tag_values[idx].active + '",';
          csv += row + "\r\n";
        }
      });

      let uri = "data:text/csv;charset=utf-8," + escape(csv);
      let link = document.createElement("a");
      link.href = uri;
      link.style = "visibility:hidden";
      link.download = saveEventFilePath + ".csv";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      setIsCsvDone(true);
    }
  }, [alarmTagData]);

  const fetchEvents = () => {
    var eventdata = { buttonClickType: "Get Events" };
    socket.emit("button click", eventdata);
    socket.on("receive events", (data) => {
      setTableData(data.result);
    });
  };

  React.useEffect(() => {
    fetchEvents();
    return () => {
      socket.removeAllListeners();
    };
  }, []);

  // data structure : {alarm_name: 'PSM3_BS_TE300', datetime: 1710303821375, active: false}
  // update SOFC 240403 by sumin, add condition - display each PSM's event log
  const renderBodyRow = (data, index) =>
    data.alarm_name.startsWith(currentPLC)
      ? {
          key: index,
          cells: [
            {
              key: "event_time",
              content: getTimestamp(
                data.datetime,
                timezone,
                data.flag_event_time_ambiguous,
              ),
            },
            // { key: 'event', content: parseEventCell(data), style: styles.event },
            {
              key: "event",
              content: parseEventCell(data),
              style: styles.event,
            },
            {
              key: "active",
              content:
                data.active === true
                  ? parseActiveCell("Active")
                  : parseActiveCell("Inactive"),
            },
          ],
        }
      : console.log("render");

  return (
    <div>
      <Modal
        trigger={<Button color="blue">Events Log</Button>}
        style={styles.toggle}
        open={open}
        onClose={handleClose}
        onOpen={handleOpen}
      >
        <Modal.Header>
          <p>EVENT LOG </p>
          <p style={{ marginLeft: "400px" }}>TOTAL ALARMS: {totalAlarms} </p>
        </Modal.Header>
        <Modal.Content>
          <div style={styles.defaults}>
            {/**원래코드 */}
            <Table
              unstackable
              compact
              headerRow={POWERPLANT_ALARM_TABLE_HEADER_ROW}
              tableData={tableData}
              renderBodyRow={renderBodyRow}
            >
              {/* 테스트코드 */}
              {/* <Table>
                            <TableHeader>
                                <TableHeaderCell key = {'date'} content={'Date'} width = {6} />
                                <TableHeaderCell key = {'event'} content={'Event'} width = {6} />
                                <TableHeaderCell key = {'active'} content={'Current Status'} width = {3} /> */}
              {/* <TableRow
                                    headerRow={POWERPLANT_ALARM_TABLE_HEADER_ROW}>
                                    const POWERPLANT_ALARM_TABLE_HEADER_ROW = [
                                        { key: 'date', content: 'Date', width: 6 },
                                        { key: 'event', content: 'Event', width: 6 },
                                        { key: 'active', content: 'Current Status', width: 3 }

                                    <TableHeaderCell 
                                        key = {'date'}
                                        content = {'Date'}
                                        width = {6}/> */}

              {/* </TableHeader>  */}
            </Table>
          </div>
        </Modal.Content>
        <Modal.Actions>
          <Button
            color={"blue"}
            size="small"
            id="1"
            content="Save"
            onClick={saveEventLogs}
          />
          <Button
            color={"green"}
            size="small"
            id="1"
            content="Refresh"
            onClick={fetchEvents}
          />
          <Button
            color={"red"}
            size="small"
            id="2"
            content="Exit"
            onClick={handleClose}
          />
        </Modal.Actions>
      </Modal>
    </div>
  );
}

const styles = {
  event_SD: {
    padding: "0",
    color: "red",
  },
  event: {
    padding: "0",
  },
  defaults: {
    alignItems: "center",
    height: "300px",
    overflow: "auto",
  },
};

const POWERPLANT_ALARM_TABLE_HEADER_ROW = [
  { key: "date", content: "Date", width: 6 },
  { key: "event", content: "Event", width: 6 },
  { key: "active", content: "Current Status", width: 3 },
];

const parseEventCell = ({ level_id, alarm_name }) =>
  alarm_name.includes("_SD_") ? (
    <div style={{ color: "red" }}> {alarm_name}</div>
  ) : (
    <div> {alarm_name} </div>
  );

const parseActiveCell = (active) => (
  <div>
    <Label
      horizontal
      size="medium"
      content={active}
      color={active === "Active" ? "green" : "gray"}
    />
  </div>
);

export default EventLog;
